/* ============================================================================
   THATSCAP CUSTOM (new file): quick-add + cart drawer refresh.
   Used by the PDP cross-sell section and the cart-drawer cross-sell row.
   Adds via /cart/add.js, re-renders the drawer + icon via the Section Rendering
   API, opens the drawer, and falls back to a full page load if anything fails.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__thatscapCartJs) return; /* guard: script may be included by more than one section */
  window.__thatscapCartJs = true;

  function refreshCartUI() {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble'
      : '/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            drawer.classList.remove('is-empty');
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var tmp2 = document.createElement('div');
          tmp2.innerHTML = sections['cart-icon-bubble'];
          var freshBubble = tmp2.querySelector('.shopify-section') || tmp2;
          bubble.innerHTML = freshBubble.innerHTML;
        }
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else if (drawer) drawer.classList.add('animate', 'active');
      });
  }

  function tcQuickAdd(variantId, button) {
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding…';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refreshCartUI();
      })
      .then(function () {
        if (button) {
          button.textContent = 'Added ✔';
          setTimeout(function () {
            button.textContent = button.dataset.originalText;
            button.removeAttribute('aria-disabled');
          }, 1600);
        }
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tc-quick-add]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    tcQuickAdd(btn.getAttribute('data-tc-quick-add'), btn);
  });
})();
